'use client';

import { useEffect } from 'react';
import clevertap from '@/utils/clevertap';
import getToken from '@/hook/getToken';
export default function PushNotificationInit() {
    useEffect(() => {
        if (!getToken()) return
        if (
            typeof window === 'undefined' ||
            typeof Notification === 'undefined'
        ) return;

        const prompt = () => {
            const permission = Notification.permission;
            console.log('Notification.permission:', permission);
            if (permission === 'default') {
                clevertap.notifications.push({
                    titleText: 'Enable Notifications?',
                    bodyText: 'We’ll send only useful updates!',
                    okButtonText: 'Allow',
                    rejectButtonText: 'No thanks',
                    serviceWorkerPath: '/clevertap_sw.js',
                    applicationServerKey: 'BOwOfg2FalQB7FhEewc6h-7MiNCobuNRiXV8989ZldgmyfUn0AhnxiN-V86ryBpC2oMR2Woi7Vf4ZW9Jx7BUn7A',
                });
                console.log('Push triggered');
            } else {
                console.log('Notification already set:', permission);
            }
        };

        const interval = setInterval(() => {
            if (clevertap?.notifications && clevertap?.notifications.push) {
                clearInterval(interval);
                prompt();
            }
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    return null;
}
